import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import React from 'react';
import ReactDOM from 'react-dom';

import 'dayjs/locale/fr';

import App from './App';
import './i18n';

import 'react-virtualized/styles.css';
import { EVENT_NAMES, initAnalytics, track } from './services/pianoAnalytics';

dayjs.extend(localizedFormat);
dayjs.locale('fr');

declare global {
  interface Window {
    VITE_PIANO_ANALYTICS_SITE_ID: string;
    VITE_PIANO_ANALYTICS_COLLECT_DOMAIN: string;
    VITE_PIANO_ANALYTICS_ENABLE: string;
  }
}

initAnalytics();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
